// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1zu9r90 {
  padding: var(--_18w76bwg);
}
._1zu9r91 {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: var(--_18w76bwl);
}
@media screen and (min-width: 768px) {
  ._1zu9r90 {
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["._1zu9r90 {\n  padding: var(--_18w76bwg);\n}\n._1zu9r91 {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  margin-top: var(--_18w76bwl);\n}\n@media screen and (min-width: 768px) {\n  ._1zu9r90 {\n    padding: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
